import {
  Circle,
  Close,
  DoneAll,
  NotificationsActive,
  TagFaces,
} from "@mui/icons-material";
import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Fab,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Tooltip,
} from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Fragment } from "react/jsx-runtime";
import moment from "moment";
import Config from "../../Utils/Config";
import styles from "../../Styles/mainHeader.module.css";
import { useContext, useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { WebSocketContext } from "../../Context/WebSocketContext";
import { updateData } from "../../Services/updateData";

export default function Notifications() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const userId = localStorage.getItem("userId");
  const websocket = useContext(WebSocketContext);

  /**
   *
   */
  useEffect(() => {
    const handleProductsUpdate = (data: any) => {
      setNotifications(data.notifications);
      setNotificationCount(data.count);
    };

    websocket.socket.emit("getNotifications", {
      userId: localStorage.getItem("userId"),
    });
    websocket.socket.on("notifications", handleProductsUpdate);

    return () => {
      websocket.socket.off("notifications", handleProductsUpdate);
    };
    // getNotificationsForUser();
  }, []);
  /**
   *
   * @param event
   */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   *
   */
  const getNotificationsForUser = () => {
    getData(`${endpoints.notifications.main}/${userId}`).then((res) => {
      if (res) {
        setNotifications(res.data.result);
        setNotificationCount(res.data.count);
      }
    });
  };

  /**
   *
   */
  const handleClose = () => {
    const unreadNotifications = notifications
      .filter((notification) => !!notification.seen === false)
      .map((notification) => notification._id);
    if (unreadNotifications.length > 0) {
      updateData(`${endpoints.notifications.markAsRead}`, {
        notificationsIds: unreadNotifications,
      }).then((res: any) => {
        if (res) {
          getNotificationsForUser();
        }
      });
    }
    setAnchorEl(null);
  };

  return (
    <>
      <Fab
        id="notificationsFab"
        size="small"
        className={`${styles.fab}`}
        onClick={handleClick}
      >
        <Badge
          badgeContent={notificationCount}
          max={Config.maxNotificationCount}
          classes={{ badge: styles.badge }}
        >
          <NotificationsActive />
        </Badge>
      </Fab>
      <Popover
        id={id}
        open={open}
        className="notificationsPopover"
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Card>
          <CardHeader
            subheader={Vocabulary.notifications}
            action={
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            }
          />
          <CardContent sx={{ padding: 0 }}>
            <List>
              {notifications && notifications.length > 0 ? (
                notifications?.map((notification: any, index: number) => {
                  return (
                    <Fragment key={notification.id}>
                      <Tooltip title={notification.message}>
                        <ListItem
                          className={`${
                            notification.seen
                              ? styles.notificationRead
                              : styles.notificationNotRead
                          }`}
                        >
                          <ListItemAvatar
                            className={`${
                              notification.seen
                                ? styles.messageRead
                                : styles.messageNotRead
                            }`}
                          >
                            {notification.seen ? <DoneAll /> : <Circle />}
                          </ListItemAvatar>
                          <ListItemText
                            className={`${
                              notification.seen
                                ? styles.messageRead
                                : styles.messageNotRead
                            }`}
                            primary={`${notification.message?.substring(
                              0,
                              50
                            )}...`}
                            secondary={moment(notification.createdAt).format(
                              Config.momentEUDateTimeFormat
                            )}
                          />
                        </ListItem>
                      </Tooltip>
                      <Divider />
                    </Fragment>
                  );
                })
              ) : (
                <ListItem>
                  <ListItemText>{Vocabulary.noNotifications} </ListItemText>
                  <ListItemAvatar>
                    <TagFaces />
                  </ListItemAvatar>
                </ListItem>
              )}
            </List>
          </CardContent>
        </Card>
      </Popover>
    </>
  );
}
